import { GItem } from "./GItem";
import { GCItem } from "./GCItem";
import * as _ from 'lodash';
import { CommonFunctions } from '../static/common-functions';
import { ID } from '@datorama/akita';
import { SItem } from "./SItem";
import { PersonSel } from "./PersonSelBus";
import { EquipFieldDef } from "./EquipFieldDef";
import { QItem } from "./QItem";
import { GGItem } from "./GGItem";
import { Item } from "./Item";
import { DateFunctions } from "../static/date-functions";
import { CommonValues } from "../static/CommonValues";
import { GItemDC } from "./GItemDC";

class AppSettings {
    ServiceMode: any;
    ARInvoiceCreation: any;
    ARInvoiceSave: any;
    InvoiceDispute: any;
    Version: any;
}
export class DQOIReferenceData {
    constructor(data: DQOIReferenceData = null) {
        if (data !== null) {
            this.id = data.id;
            this.companyId = data.companyId;
            this.prioritys = data.prioritys;
            this.locations = data.locations;
            this.locationsInactive = data.locationsInactive;
            //this.geoLocations = data.geoLocations;
            this.dispatchClassifications = data.dispatchClassifications;
            this.dispatchStatus = data.dispatchStatus;
            this.quoteStatus = data.quoteStatus;
            this.orderStatus = data.orderStatus;
            this.potentialCustomers = data.potentialCustomers;
            this.potentialLocations = data.potentialLocations;
            this.customers = this.getGItemDCs(data.customers);
            this.cpCustomers = this.getGItemDCs(data.cpCustomers);
            this.customersInactive = this.getGItemDCs(data.customersInactive);
            this.customersOnHold = data.customersOnHold;
            this.customersMarkedOnHold = this.getCustomersMarkedOnHold(data.customers, data.customersOnHold);
            this.repairCat = data.repairCat;
            this.accountClasses = data.accountClasses;
            this.cpAccountClasses = data.cpAccountClasses;
            this.accountClassesSubClasses = data.accountClassesSubClasses;
            this.prioritySubTypes = data.prioritySubTypes;
            this.taxCodes = data.taxCodes;
            this.terms = data.terms;
            this.invoiceStatus = data.invoiceStatus;
            this.manufacturers = data.manufacturers;
            this.manufacturerTypes = data.manufacturerTypes;
            this.generalContractors = data.generalContractors;
            this.shippingMethods = data.shippingMethods;
            this.creditCards = data.creditCards;
            this.suppliers = data.suppliers;
            this.supplierLocations = data.supplierLocations;
            this.cpSuppliers = data.cpSuppliers;
            this.zgSuppliers = data.zgSuppliers;
            this.cpSupplierLocations = data.cpSupplierLocations;
            this.states = data.states;
            this.allStates = data.allStates;
            this.acctMgrs = data.acctMgrs;
            this.svcMgrs = data.svcMgrs;
            this.billers = data.billers;
            this.technicians = data.technicians;
            this.contAdmins = data.contAdmins;
            this.dispErrCat = data.dispErrCat;
            this.ordErrCat = data.ordErrCat;
            this.relJobType = data.relJobType;
            this.warehouses = data.warehouses;
            this.cpWarehouses = data.cpWarehouses;
            this.dispAssignStatus = data.dispAssignStatus;
            this.timeClasses = data.timeClasses;
            this.timeTypes = data.timeTypes;
            this.laborTypes = data.laborTypes;
            this.personsSel = data.personsSel;
            this.personsAssignPurchase = data.personsAssignPurchase;
            this.equipFieldDef = data.equipFieldDef;
            this.reimbursementType = data.reimbursementType;
            this.billingCodes = data.billingCodes;
            this.divisions = data.divisions;
            this.cpDivisions = data.cpDivisions;
            this.constDivisions = data.constDivisions;
            this.regions = data.regions;
            this.cpRegions = data.cpRegions;
            this.srvConst = data.srvConst;
            this.vendorReturnStatusCodes = data.vendorReturnStatusCodes;
            this.orderBillStatusCodes = data.orderBillStatusCodes;
            this.vendorCreditStatusCodes = data.vendorCreditStatusCodes;
            this.scheduleFrequency = data.scheduleFrequency;
            this.paymentMethods = data.paymentMethods;
            this.collNoteCodes = data.collNoteCodes;
            this._hasData = CommonFunctions.hasArrayValue(this.locations);
            this.assetStatus = data.assetStatus;
            this.customForms = data.customForms;
            this.contactTypes = data.contactTypes;
            this.contractTypes = data.contractTypes;
            this.customerProcedureGroups = data.customerProcedureGroups;
            this.unions = data.unions;
            this.scheduleFrequencys = data.scheduleFrequencys;
            this.vehicles = data.vehicles;
            this.vehicleServiceTypes = data.vehicleServiceTypes;
            this.vehicleContractTerms = data.vehicleContractTerms;
            this.vehicleRegulatedTypes = data.vehicleRegulatedTypes;
            this.vehicleTypes = data.vehicleTypes;
            this.vehicleConstructionTypes = data.vehicleConstructionTypes;
            this.vehicleStatus = data.vehicleStatus;
            this.vehiclePowerTrainTypes = data.vehiclePowerTrainTypes;
            this.onCallRegions = data.onCallRegions;
            this.customersDRCC = data.customersDRCC;
            this.companyBranches = data.companyBranches;
            this.dispatchKudosCat = data.dispatchKudosCat;
            this.serviceMode = CommonFunctions.getStringValueIfNull(data.serviceMode, "0");
            this.ARInvoiceCreation = CommonFunctions.getNumberValue(data.ARInvoiceCreation);
            this.lastUpdated = DateFunctions.getDate(data.lastUpdated);
            this.dispProbCodes = data.dispProbCodes;
            this.dispFailureCodes = data.dispFailureCodes;
            this.dispActionCodes = data.dispActionCodes;
            this.dispSummaryCodes = data.dispSummaryCodes;
            this.dispCauseCodes = data.dispCauseCodes;
            this.dispCostAdjCodes = data.dispCostAdjCodes;
            this.thirdPartySystems = data.thirdPartySystems;
            this.invLineChangeCodes = data.invLineChangeCodes;

            this.lastUpdatedDBDate = DateFunctions.getDate(data.lastUpdatedDBDate);
            const tempDate = new Date(this.lastUpdatedDBDate);
            tempDate.setMinutes(tempDate.getMinutes() + (data.CacheExpiresIn ?? 60));
            this.cacheExpiresAt = tempDate;
            this.accountClassesService = _.cloneDeep(this.accountClasses.filter(s => s.other === 0 || s.other === 1));
            this.accountClassesConstruction = _.cloneDeep(this.accountClasses.filter(s => s.other === 0 || s.other === 2));
            this.cpAccountClassesService = _.cloneDeep(this.cpAccountClasses.filter(s => s.other === 0 || s.other === 1));
            this.cpAccountClassesConstruction = _.cloneDeep(this.cpAccountClasses.filter(s => s.other === 0 || s.other === 2));
            this.relatedJobTypesForJobs = _.cloneDeep(this.relJobType.filter(s => s.value.toLowerCase() !== CommonValues.RelatedJobType_Contract));
            this.personLocation = data.personLocation;
            this.orderPriceOverideReasons = data.orderPriceOverideReasons;
            this.miscDeductTypes = _.cloneDeep(data.miscDeductTypes);
            this.laborTypesOT = this.laborTypes.filter(a => a.description === 'DT' || a.description === 'OT');
            this.laborTypesOT.push({ category: "", reference: "", description: "As per Time", value: "10000000-0000-0000-0000-000000000001" });
            this.customersDRCC = data.customersDRCC;
            this.expenseMatTypes = data.expenseMatTypes;
            this.appSettings = data.appSettings;
            this.invDispStatuses = data.invDispStatuses;
            this.creditMemoStatuses = data.creditMemoStatuses;
            this.creditMemoReasonCodes = data.creditMemoReasonCodes;
            this.quoteAutomationTypes = data.quoteAutomationTypes;
            this.assetTypes = data.assetTypes;
            this.rankOrders = data.rankOrders;
            this.noTimeTypes = data.noTimeTypes;
            this.marketSegments = data.marketSegments;
            this.equipmentTypes = data.equipmentTypes;
            this.payrollCompanyCodes = data.payrollCompanyCodes;
            
            this.isDispatchCallbackItems = [
                { description: "", flag: null, value: null, category: null, canSelect: true, other: 0 }
               ,{ description: "Is Not Callback", flag: null, value: null, category: null, canSelect: true, other: 2 }
               ,{ description: "Is Callback", flag: null, value: null, category: null, canSelect: true, other: 1 }
            ]
        }
        if (!CommonFunctions.hasValue(this.appSettings)) {
            this.appSettings = new AppSettings();
        }

    }
    getGItemDCs(items: GItemDC[]): GItemDC[] {
        let arr: GItemDC[] = [];
        if (CommonFunctions.hasArrayElementValue(items)) {
            for (let i = 0; i < items.length; i++) {
                let obj = new GItemDC(items[i]);
                arr.push(obj);
            }
        }
        return arr;
    }
    get ClimateProsCus(): GItem {
        let item: GItem = new GItem();
        if (this.hasData) {
            item = this.customers.find(s => s.description === "Climate Pros");
        }
        //        var customer = this.customers.find(s => s.description === "Climate Pros");
        return item;
    }

    isEqualTo(data: DQOIReferenceData): boolean {
        return data && data.lastUpdatedDBDate.getTime() === this.lastUpdatedDBDate?.getTime();
    }

    id: ID;
    companyId: string;
    prioritys: GItem[];
    locations: GCItem[] = null;
    potentialLocations: GCItem[] = null;
    locationsInactive: GCItem[] = null;
    dispatchClassifications: GItem[];
    dispatchStatus: GItem[];
    quoteStatus: GItem[];
    orderStatus: GItem[];
    customers: GItemDC[];
    cpCustomers: GItemDC[];
    customersMarkedOnHold: GItemDC[];
    potentialCustomers: GItemDC[];
    customersInactive: GItemDC[];
    customersOnHold: GItem[];
    repairCat: GItem[];
    accountClasses: GGItem[];
    cpAccountClasses: GGItem[];
    accountClassesSubClasses: GGItem[];
    prioritySubTypes: GGItem[];
    accountClassesService: GGItem[];
    orderPriceOverideReasons:GGItem[]
    accountClassesConstruction: GGItem[];
    cpAccountClassesService: GGItem[];
    cpAccountClassesConstruction: GGItem[];
    taxCodes: GItem[];
    terms: GItem[];
    invoiceStatus: GItem[];
    manufacturers: GItem[];
    manufacturerTypes: GItem[];
    generalContractors: GItem[];
    shippingMethods: GItem[];
    creditCards: GItem[];
    suppliers: GGItem[];
    supplierLocations: GItem[];
    cpSuppliers: GGItem[];
    zgSuppliers: GGItem[];
    cpSupplierLocations: GItem[];
    states: GItem[];
    allStates: GItem[];
    acctMgrs: GItem[];
    svcMgrs: GItem[];
    billers: GItem[];
    technicians: GItem[];
    contAdmins: GItem[];
    dispErrCat: GItem[];
    ordErrCat: GItem[];
    relJobType: GGItem[];
    relatedJobTypesForJobs: GGItem[];
    warehouses: GItem[];
    cpWarehouses: GItem[];
    dispAssignStatus: GItem[];
    timeClasses: GItem[];
    timeTypes: GItem[];
    laborTypesOT: GItem[];
    laborTypes: GItem[];
    personsSel: PersonSel[];
    personsAssignPurchase: GItem[];
    equipFieldDef: EquipFieldDef;
    reimbursementType: GItem[];
    billingCodes: GItem[];
    divisions: GItem[];
    cpDivisions: GItem[];
    constDivisions: GItem[];
    regions: GItem[];
    cpRegions: GItem[];
    srvConst: GItem[];
    vendorReturnStatusCodes: GItem[];
    orderBillStatusCodes: GItem[];
    vendorCreditStatusCodes: GItem[];
    scheduleFrequency: QItem[];
    paymentMethods: GItem[];
    contactTypes: GItem[];
    contractTypes: GItem[];
    customerProcedureGroups: GItem[];
    unions: GItem[];
    collNoteCodes: GItem[];

    assetStatus: GItem[];
    customForms: GItem[];
    scheduleFrequencys: GItem[];
    vehicleServiceTypes: GGItem[];
    vehicleContractTerms: SItem[];
    vehicleRegulatedTypes: SItem[];
    vehicleTypes: SItem[];
    vehicleConstructionTypes: SItem[];
    vehicleStatus: GGItem[];
    vehiclePowerTrainTypes: GGItem[];
    companyBranches: GGItem[];
    dispatchKudosCat: GItem[];
    dispProbCodes: GItem[];
    dispFailureCodes: GItem[];
    dispActionCodes: GItem[];
    dispSummaryCodes: GItem[];
    dispCauseCodes: GItem[];
    dispCostAdjCodes: GItem[];
    thirdPartySystems: GItem[];
    personLocation: GItem[];
    miscDeductTypes: GItem[];
    vehicles: GItem[];
    onCallRegions: GItem[];
    invLineChangeCodes: GItem[];
    serviceMode: any;
    ARInvoiceCreation: number;
    lastUpdated: Date;
    lastUpdatedDBDate: Date;
    CacheExpiresIn: number;
    cacheExpiresAt: Date;
    customersDRCC: GItem[];
    appSettings: AppSettings;
    expenseMatTypes: SItem[];
    invDispStatuses: Item[];
    creditMemoStatuses: GItem[];
    creditMemoReasonCodes: GItem[];
    quoteAutomationTypes: GItem[];
    assetTypes: GItem[];
    noTimeTypes: GItem[];
    isDispatchCallbackItems: GGItem[];
    rankOrders: GGItem[];
    marketSegments: GGItem[];
    equipmentTypes: GGItem[];
    payrollCompanyCodes: GItem[];
    protected _hasData: boolean = false;

    get geoLocations(): GCItem[] {
        return this.locations;
    }
    get hasData(): boolean {
        return this._hasData;
    }
    getStatus(id: any) {
        if (this.hasData) {
            let item = this.dispatchStatus.filter(a => a.value === id);
            if (CommonFunctions.hasArrayValue(item)) {
                return item[0].description;
            }
        }
        return "";
    }

    getCustomersMarkedOnHold(customers: GItemDC[], customersOnHold: GItem[]): GItemDC[] {
        let customersList = this.getGItemDCs(customers);
        let onHoldSet = new Set(customersOnHold.map(c => c.value)); // Assuming 'value' uniquely identifies customers

        return customersList.map(customer => {
            let modifiedCustomer = new GItemDC(customer);
            modifiedCustomer.canSelect = onHoldSet.has(customer.value) ? false : true;
            return modifiedCustomer;
        });
    }

    getManufacturer(id: any) {
        if (this.hasData) {
            let item = this.manufacturers.filter(a => a.value === id);
            if (CommonFunctions.hasArrayValue(item)) {
                return item[0].description;
            }
        }
        return "";
    }

    getManufacturerType(id: any) {
        if (this.hasData) {
            let item = this.manufacturerTypes.filter(a => a.value === id);
            if (CommonFunctions.hasArrayValue(item)) {
                return item[0].description;
            }
        }
        return "";
    }
    isCustomerOnHold(id: any): boolean {
        if (this.hasData) {
            let item = this.customersOnHold.find(a => a.value === id);
            if (CommonFunctions.hasValue(item)) {
                return true;
            }
        }
        return false;

    }
    getQuoteStatus(id: any) {
        if (this.hasData) {
            let item = this.quoteStatus.filter(a => a.value === id);

            if (CommonFunctions.hasArrayValue(item)) {
                return item[0].description;
            }
        }
        return "";
    }
    getCompanyBranch(id: any) {
        if (this.hasData) {
            let item = this.companyBranches.filter(a => a.value === id);

            if (CommonFunctions.hasArrayValue(item)) {
                return item[0].description;
            }
        }
        return "";
    }

    getAssetStatus(id: any) {
        if (this.hasData) {
            let item = this.assetStatus.filter(a => a.value === id);

            if (CommonFunctions.hasArrayValue(item)) {
                return item[0].description;
            }
        }
        return "";
    }
    getLocationAddIfInactive(id: any): GCItem {
        if (this.hasData) {
            let item: GCItem = this.locations.find(s => s.value === id);
            if (!item) {
                item = this.locationsInactive.find(s => s.value === id);
                if (item) {
                    let tmpItem: GCItem = new GCItem(item);
                    //tmpItem.canSelect = false;
                    this.locations = [...this.locations, tmpItem]; //.push(tmpItem);
                }
            }
            return item;
        }
        return new GCItem();
    }
    customerLocationAddIfInactive(customerId: any, locationId: any) {
        this.getCustomerAddIfInactive(customerId);
        this.getLocationAddIfInactive(locationId);
    }
    getCustomerAddIfInactive(id: any): GItemDC {
        if (this.hasData) {
            let item: GItemDC = this.customers.find(s => s.value === id);
            if (!item) {
                item = this.customersInactive.find(s => s.value === id);
                if (item) {
                    let tmpItem: GItemDC = new GItemDC(item);
                    tmpItem.canSelect = false;
                    this.customers = [...this.customers, tmpItem]; //.push(tmpItem);
                }
            }
            return item;
        }
        return new GItemDC();
    }
    getCustomer(id: any): GItemDC {
        if (this.hasData) {
            let item: GItemDC = this.customers.find(s => s.value === id);
            if (!item) {
                item = this.customersInactive.find(s => s.value === id);
            }
            if (!item && this.cpCustomers) {
                item = this.cpCustomers.find(s => s.value === id);
            }
            return item;
        }
        return new GItemDC();
    }
    getCustomerDCValue(id: any, key: string): any {
        let retVal: any = null;
        let item: GItemDC = this.getCustomer(id);
        if (item) {
            retVal = item.getDCValue(key);
        }
        return retVal;
    }
    getCustomerDesc(id: any): string {
        let desc: string = "";
        let item: GItem = this.getCustomer(id);
        if (item) {
            desc = item.description;
        }
        return desc;
    }
    getLocation(id: any): GCItem {
        if (this.hasData) {
            let item: GCItem = this.locations.find(s => s.value === id);
            if (!item) {
                item = this.locationsInactive.find(s => s.value === id);
            }
            return item;
        }
        return new GCItem();
    }
    getLocationDesc(id: any) {
        let desc: string = "";
        let item: GCItem = this.getLocation(id);
        if (item) {
            desc = item.description;
        }
        return desc;
    }
    getCustomerLocations(id: any) {
        if (this.hasData) {
            let locations = this.locations.filter(a => a.category === id);

            return locations;
        }
        return [];
    }
    getMultiCustomerLocations(ids: any) {
        if (this.hasData) {
            let locations = this.locations.filter(a => ids.indexOf(a.category) > -1);

            return locations;
        }
        return [];
    }
    getCustomerGeoLocations(id: any) {
        if (this.hasData) {
            let locations = this.geoLocations.filter(a => a.category === id);

            return locations;
        }
        return [];
    }
    isTechnician(id: any) {
        if (this.hasData) {
            let locations = this.technicians.filter(a => a.value === id);

            return (locations.length > 0);
        }
        return false;
    }
    getSupplierLocations(id: any) {
        if (this.hasData) {
            let locations = this.supplierLocations.filter(a => a.category === id);

            return locations;
        }
        return [];
    }
    getPersonLocationId(id: any) {
        if (this.hasData) {
            let item = this.personLocation.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.category;
            }
        }
        return "";
    }
    getOrderBillStatusCode(id: any) {
        if (this.hasData) {
            let item = this.orderBillStatusCodes.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getMiscDeductTypes(id: any) {
        if (this.hasData && this.miscDeductTypes) {
            let item = this.miscDeductTypes.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }

    getVendorCreditStatusCode(id: any) {
        if (this.hasData) {
            let item = this.vendorCreditStatusCodes.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getScheduleFrequencyName(id: any) {
        if (this.hasData) {
            let item = this.scheduleFrequency.find(a => a.id === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getUnionName(id: any) {
        if (this.hasData) {
            let item = this.unions.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    personsActive() {
        if (this.hasData) {
            return this.personsSel.filter(s => s.isActive === true);
        }
        return [];
    }
    personsInActive(itemArgs: { dataItem: any, index: number }) {
        if (itemArgs.dataItem == null || itemArgs.dataItem.isActive == null) return false;
        return !itemArgs.dataItem.isActive;
    }

    warehouseInActive(itemArgs: { dataItem: any, index: number }) {
        if (itemArgs.dataItem == null || itemArgs.dataItem.canSelect == null) return false;
        return !itemArgs.dataItem.canSelect;
    }
    acctClassesSvcInActive(itemArgs: { dataItem: any, index: number }) {
        if (itemArgs.dataItem == null || itemArgs.dataItem.isActive == null) return false;
        return !itemArgs.dataItem.isActive;
    }
    anyItemNotCanSelect(itemArgs: { dataItem: any, index: number }) {
        if (itemArgs.dataItem == null || itemArgs.dataItem.canSelect == null) return false;
        return !itemArgs.dataItem.canSelect;
    }
    //Used for feature flag purposes.
    returnNull() {
        return null;
    }

    suppliersInActive(itemArgs: { dataItem: any, index: number }) {
        if (itemArgs.dataItem == null || itemArgs.dataItem.canSelect == null) return false;
        return !itemArgs.dataItem.canSelect;
    }
    supplierLocationsInActive(itemArgs: { dataItem: any, index: number }) {
        if (itemArgs.dataItem == null || itemArgs.dataItem.canSelect == null) return false;
        return !itemArgs.dataItem.canSelect;
    }
    getLaborTypes(id: any): string {

        if (this.hasData) {
            let item = this.laborTypes.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getTimeTypes(id: any): string {

        if (this.hasData) {
            let item = this.timeTypes.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getWarehouse(id: any): string {

        if (this.hasData) {
            let item = this.warehouses.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getCpWarehouse(id: any): string {

        if (this.hasData) {
            let item = this.cpWarehouses.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getUser(id: any): string {

        if (this.hasData && id) {
            let item = this.personsSel.find(a => a.userId === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getPerson(id: any): string {

        if (this.hasData && id) {
            let item = this.personsSel.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getPersonEmpNo(id: any): string {

        if (this.hasData && id) {
            let item = this.personsSel.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.empNo;
            }
        }
        return "";
    }
    getDispErrCat(id: any): string {

        if (this.hasData) {
            let item = this.dispErrCat.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getOrdErrCat(id: any): string {

        if (this.hasData) {
            let item = this.ordErrCat.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getManufacturerDesc(id: any): string {

        if (this.hasData) {
            let item = this.manufacturers.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getManufacturerTypeDesc(id: any): string {

        if (this.hasData) {
            let item = this.manufacturerTypes.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    getBillingCodeDesc(id: any): string {

        if (this.hasData) {
            let item = this.billingCodes.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }

    getReimbursementTypeDesc(id: any): string {

        if (this.hasData) {
            let item = this.reimbursementType.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }

    getActiveContAdmins(): GItem[] {
        if (this.contAdmins) {
            return this.contAdmins.filter(s => s.canSelect === true);
        }
        return [];
    }
    //get accountClassesService(): GGItem[] {
    //    if (this.hasData) {
    //        return this.accountClasses.filter(s => s.other === 0 || s.other === 1);
    //    }
    //    return [];
    //}
    //get accountClassesConstruction(): GGItem[] {
    //    if (this.hasData) {
    //        return this.accountClasses.filter(s => s.other === 0 || s.other === 2);
    //    }
    //    return [];
    //}

    getAccountClassDesc(id: any): string {

        if (!this.accountClasses) { return ""; }
        let item = this.accountClasses.find(a => a.value === id);

        if (CommonFunctions.hasValue(item)) {
            return item.description;
        }
        return "";
    }
    getPaymentMethodDesc(id: any): string {

        if (!this.paymentMethods) { return ""; }
        let returnVal: string = "";
        if (this.hasData) {
            let item = this.paymentMethods.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                returnVal = item.description;
            }
        }
        return returnVal;
    }
    getCollectionNoteCodeDesc(id: any): string {

        if (!this.collNoteCodes) { return ""; }
        let returnVal: string = "";
        if (this.hasData) {
            let item = this.collNoteCodes.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                returnVal = item.description;
            }
        }
        return returnVal;
    }
    getContactTypeDesc(id: any): string {

        if (!this.contactTypes) { return ""; }
        let item = this.contactTypes.find(a => a.value === id);

        if (CommonFunctions.hasValue(item)) {
            return item.description;
        }
        return "";
    }
    getCustomerProcedureGroupsDesc(id: any): string {

        if (!this.customerProcedureGroups) { return ""; }
        let item = this.customerProcedureGroups.find(a => a.value === id);

        if (CommonFunctions.hasValue(item)) {
            return item.description;
        }
        return "";
    }
    getVehicleServiceTypeDesc(id: any): string {

        if (!this.vehicleServiceTypes) { return ""; }
        let returnVal: string = "";
        if (this.hasData) {
            let item = this.vehicleServiceTypes.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                returnVal = item.description;
            }
        }
        return returnVal;
    }
    getDispatchKudosCatDesc(id: any): string {

        if (!this.dispatchKudosCat) { return ""; }
        let returnVal: string = "";
        if (this.hasData) {
            let item = this.dispatchKudosCat.find(a => a.value === id);

            if (CommonFunctions.hasValue(item)) {
                returnVal = item.description;
            }
        }
        return returnVal;
    }
    getInvLineChangeCode(id: any): GItem {
        let item: GItem = new GItem;
        if (CommonFunctions.hasGuidValue(id) && CommonFunctions.hasArrayElementValue(this.invLineChangeCodes)) {
            item = this.invLineChangeCodes.find(a => a.value === id);
        }
        return item;
    }
    getDispCostAdjCode(id: any): GItem {
        let item: GItem = new GItem;
        if (CommonFunctions.hasArrayElementValue(this.dispCostAdjCodes)) {
            item = this.dispCostAdjCodes.find(a => a.value === id);
        }
        return item;
    }
    getDispatchStatusForFldSvcSupQV(): GItem[] {
        return this.dispatchStatus.filter(s =>
            s.value.toLowerCase() === CommonValues.Dispatch_FollowUp
            || s.value.toLowerCase() === CommonValues.Dispatch_NeedsParts
            || s.value.toLowerCase() === CommonValues.Dispatch_ReadyForBilling
            || s.value.toLowerCase() === CommonValues.Dispatch_WH_ShopDuties);
    }
    getGItemListWithBlank(list: GItem[]): GItem[] {
        let retList: GItem[] = CommonFunctions.hasArrayElementValue(list) ? _.cloneDeep(list) : [];
        let blankItem: GItem = { description: "", value: null, category: null, canSelect: true, reference: null };
        try {
            if (CommonFunctions.hasArrayElementValue(list)) {
                let hasBlankInList = list.filter(s => s.description.trim().length === 0);
                if (!CommonFunctions.hasArrayElementValue(hasBlankInList)) {
                    retList.splice(0, 0, blankItem);
                }
            }
            else {
                retList.push(blankItem);
            }
        }
        catch {

        }
        return retList;
    }
    //get relatedJobTypesForJobs(): GGItem[] {
    //    let retList: GGItem[] = [];
    //    if (CommonFunctions.hasArrayElementValue(this.relJobType)) {
    //        retList = this.relJobType.filter(s => s.value.toLowerCase() !== CommonValues.RelatedJobType_Contract);
    //    }
    //    return retList;
    //}
    getRelatedJobType(id: any): GGItem {
        if (this.hasData) {
            return this.relJobType.find(s => s.value === id);
        }
        return null;
    }

    addLocalWarehouse(warehouse: GItem) {
        try {
            this.warehouses.push(warehouse);
            this.warehouses.sort((a, b) => (a.description > b.description) ? 1 : -1);
        }
        catch (err) {

        }

    }
    getSupplierName(id: any): string {
        if (this.hasData) {
            let item = this.suppliers.find(a => a.value === id);
            if (CommonFunctions.hasValue(item)) {
                return item.description;
            }
        }
        return "";
    }
    //Temporarily change for all
    customerDoesntRequireChangeCode(id: any): boolean {
        return true;
    //    if (this.hasData) {
    //        let item = this.customersDRCC.find(a => a.value === id);
    //        if (CommonFunctions.hasValue(item)) {
    //            return true;
    //        }20167
    //        else {
    //            return false;
    //        }
    //    }
    //    return false;
    }

    getStateNameByStateCode(id: any): string {
        if (this.hasData) {
            let item = this.allStates.filter(a => a.value === id);
            if (CommonFunctions.hasArrayValue(item)) {
                return item[0].description;
            }
        }
        return "";
    }

}
